var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIncPayrollP(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 15.75H18.75M11.75 16.75H3.75C2.95435 16.75 2.19129 16.4339 1.62868 15.8713C1.06607 15.3087 0.75 14.5456 0.75 13.75C0.75 12.9544 1.06607 12.1913 1.62868 11.6287C2.19129 11.0661 2.95435 10.75 3.75 10.75H14.75C13.9544 10.75 13.1913 11.0661 12.6287 11.6287C12.0661 12.1913 11.75 12.9544 11.75 13.75M18.75 11.75V2.75C18.75 2.21957 18.5393 1.71086 18.1642 1.33579C17.7891 0.960714 17.2804 0.75 16.75 0.75H6.75C6.21957 0.75 5.71086 0.960714 5.33579 1.33579C4.96071 1.71086 4.75 2.21957 4.75 2.75V10.75",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIncPayrollP);
export default __webpack_public_path__ + "static/media/icon_inc_payrollP.ae986eec23b9750432eea2aafc743bad.svg";
export { ForwardRef as ReactComponent };